export default __webpack_public_path__ + "static/Spectt-bb5a354f7515adb79b6e24c41b2d56f8.jpg";